import { render } from "./component-gsxw.vue?vue&type=template&id=49b918ca"
import script from "./component-gsxw.vue?vue&type=script&lang=js"
export * from "./component-gsxw.vue?vue&type=script&lang=js"

import "./component-gsxw.vue?vue&type=style&index=0&id=49b918ca&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__